

















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class IconAddReturn extends Vue {
    @Prop({ required: false }) readonly color?: string;
}
